import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgText = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 448 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M40 48c-4.4 0-8 3.6-8 8v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V56c0-13.3 10.7-24 24-24H224 408c13.3 0 24 10.7 24 24v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V56c0-4.4-3.6-8-8-8H232l0 416h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H224 136c-4.4 0-8-3.6-8-8s3.6-8 8-8h80l0-416H40z" })
});
export default SvgText;
